// Process-stable detection of third-party iframe embed mode.
//
// `chat.zenvoya.ai` runs inside the same-origin `zenvoya.ai` marketing iframe
// in production via the `#app_domain` channel. That same-origin path must NOT
// trigger embed-mode behavior (postMessage resize, partner-origin SSO accept).
//
// Embed mode is opted into explicitly by the partner-facing loader script
// (`public/embed.js`) appending `?embed=1` to the iframe URL. The loader is
// the only caller that sets this flag.

let cached: boolean | null = null;

export function isEmbedMode(): boolean {
  if (cached !== null) return cached;
  if (typeof window === "undefined") {
    cached = false;
    return cached;
  }
  try {
    const value = new URLSearchParams(window.location.search).get("embed");
    cached = value === "1" || value === "true";
  } catch {
    cached = false;
  }
  return cached;
}

// Allowlist of partner origins permitted to send the existing same-origin SSO
// payload (`{ id, loggedIn, jwt }`) to AppRoutes.tsx's window-message listener.
// Ship empty; populate per-partner once SSO integration is signed off.
export const PARTNER_ORIGIN_ALLOWLIST: readonly string[] = [];

export function isAllowedPartnerOrigin(origin: string): boolean {
  return PARTNER_ORIGIN_ALLOWLIST.includes(origin);
}
